import React from 'react'
import styles from './InitialPage.module.scss'
import wp from '../../image/InitialPage/touch.svg'


const InitialPage = ({isOpen, isRus}) => {
    return (
        <section className={styles.main}>
            <div className={styles.overlay}>
                <div className={styles.container}>
                    <h1 className={styles.title}>{ isRus  ? 'Шалимов Игорь Олегович' : 'Igor Shalimov'}</h1>
                    <p className={styles.text}>{ isRus  ? 'Независимый бизнес консультант' : 'Independent business consultant'}</p>
                    <div className={styles.box_button}>
                        <button className={styles.button} type='button' onClick={isOpen}>{ isRus  ? 'получить консультацию' : 'get a consultation'} <span className={styles.glare}></span> <img src={wp} alt="Whatsapp"/></button>
                    </div>
                </div>
            </div> 
        </section>
    )
}

export default InitialPage